const mergeStyles = (styles: (string | undefined)[]): string =>
  styles.join(" ");

const classNames = (...classes: (string | undefined | boolean)[]): string => {
  return classes.filter(Boolean).join(" ");
};

export { mergeStyles, classNames };
